/**
 * Catalog of available web fonts. The actual @font-face declarations are loaded
 * in public/index.html via Google Fonts.
 *
 * - `family`: CSS font-family value (with sensible fallback stack)
 * - `category`: groups fonts for the picker
 * - `weights`: weights we loaded from Google Fonts for this family
 */
export const FONT_LIBRARY = [
  { id: "inter", label: "Inter", family: "'Inter', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "poppins", label: "Poppins", family: "'Poppins', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "montserrat", label: "Montserrat", family: "'Montserrat', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "lato", label: "Lato", family: "'Lato', system-ui, sans-serif", category: "Sans", weights: [400, 700, 900] },
  { id: "open_sans", label: "Open Sans", family: "'Open Sans', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },
  { id: "roboto", label: "Roboto", family: "'Roboto', system-ui, sans-serif", category: "Sans", weights: [400, 500, 700, 900] },
  { id: "nunito_sans", label: "Nunito Sans", family: "'Nunito Sans', system-ui, sans-serif", category: "Sans", weights: [400, 600, 700, 800] },
  { id: "work_sans", label: "Work Sans", family: "'Work Sans', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },
  { id: "dm_sans", label: "DM Sans", family: "'DM Sans', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },
  { id: "manrope", label: "Manrope", family: "'Manrope', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "plus_jakarta_sans", label: "Plus Jakarta Sans", family: "'Plus Jakarta Sans', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "source_sans_3", label: "Source Sans 3", family: "'Source Sans 3', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },
  { id: "space_grotesk", label: "Space Grotesk", family: "'Space Grotesk', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },
  { id: "urbanist", label: "Urbanist", family: "'Urbanist', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "raleway", label: "Raleway", family: "'Raleway', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700, 800] },
  { id: "josefin_sans", label: "Josefin Sans", family: "'Josefin Sans', system-ui, sans-serif", category: "Sans", weights: [400, 500, 600, 700] },

  { id: "playfair_display", label: "Playfair Display", family: "'Playfair Display', Georgia, serif", category: "Serif", weights: [400, 500, 600, 700, 800] },
  { id: "cormorant_garamond", label: "Cormorant Garamond", family: "'Cormorant Garamond', Georgia, serif", category: "Serif", weights: [400, 500, 600, 700] },
  { id: "libre_baskerville", label: "Libre Baskerville", family: "'Libre Baskerville', Georgia, serif", category: "Serif", weights: [400, 700] },
  { id: "merriweather", label: "Merriweather", family: "'Merriweather', Georgia, serif", category: "Serif", weights: [400, 700, 900] },
  { id: "lora", label: "Lora", family: "'Lora', Georgia, serif", category: "Serif", weights: [400, 500, 600, 700] },
  { id: "prata", label: "Prata", family: "'Prata', Georgia, serif", category: "Serif", weights: [400] },

  { id: "oswald", label: "Oswald", family: "'Oswald', Impact, sans-serif", category: "Display", weights: [400, 500, 600, 700] },
  { id: "bebas_neue", label: "Bebas Neue", family: "'Bebas Neue', Impact, sans-serif", category: "Display", weights: [400] },
];

export function fontById(id) {
  if (!id) return null;
  return FONT_LIBRARY.find((f) => f.id === id) || null;
}

export const FONT_WEIGHTS = [
  { id: 400, label: "400 · Regular" },
  { id: 500, label: "500 · Medium" },
  { id: 600, label: "600 · Semibold" },
  { id: 700, label: "700 · Bold" },
  { id: 800, label: "800 · Extra bold" },
];
